"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./SliderComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SliderComponent = function SliderComponent(_ref) {
  var step = _ref.step,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      onAfterChange = _ref.onAfterChange,
      autoFocus = _ref.autoFocus,
      disabled = _ref.disabled,
      dots = _ref.dots,
      included = _ref.included,
      max = _ref.max,
      min = _ref.min,
      reverse = _ref.reverse,
      tooltipPlacement = _ref.tooltipPlacement,
      tooltipVisible = _ref.tooltipVisible,
      vertical = _ref.vertical,
      width = _ref.width,
      height = _ref.height,
      rangeDefaultValue = _ref.rangeDefaultValue,
      draggableTrack = _ref.draggableTrack,
      tipFormatter = _ref.tipFormatter;
  var DEFAULT_PROPS = {
    style: {
      width: width ? width : 220,
      heigth: height ? height : 4
    },
    step: step,
    onChange: onChange,
    onAfterChange: onAfterChange,
    autoFocus: autoFocus || false,
    disabled: disabled || false,
    dots: dots || false,
    included: included || true,
    max: max,
    min: min,
    reverse: reverse || false,
    tooltipPlacement: tooltipPlacement,
    tooltipVisible: tooltipVisible,
    vertical: vertical || false,
    draggableTrack: draggableTrack || false,
    tipFormatter: tipFormatter || null
  };
  var color = {
    handleStyle: "#336699",
    trackStyle: "#336699"
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, defaultValue ? /*#__PURE__*/_react["default"].createElement(_antd.Slider, _extends({}, DEFAULT_PROPS, {
    defaultValue: defaultValue,
    trackStyle: {
      backgroundColor: color.trackStyle
    },
    handleStyle: {
      borderColor: color.handleStyle
    }
  })) : /*#__PURE__*/_react["default"].createElement(_antd.Slider, _extends({}, DEFAULT_PROPS, {
    range: true,
    defaultValue: rangeDefaultValue || [],
    trackStyle: {
      backgroundColor: color.trackStyle
    },
    handleStyle: {
      borderColor: color.handleStyle
    }
  })));
};

var _default = SliderComponent;
exports["default"] = _default;